import React, { useState, useEffect } from 'react'
import '../Statistics/Statistics.css'
import './Dashboards.css'
import endpoints from '../endpoints.json'
import Graph from './Graph'
import { useLocation, useNavigate } from 'react-router-dom'
//"SELECT  SUM(o.CarrAfterReseller*o.ProbabilityDecimal) AS WeightedCarr,  EOMONTH(o.EstimatedCloseDate) AS [Month],  a.BusinessArea,  o.Category  FROM dynamics.opportunities o JOIN dynamics.accounts a ON a.AccountId = o.AccountId  WHERE o.Status IN ('Won','In Progress')  AND  o.EstimatedCloseDate > '2023'  GROUP BY  a.BusinessArea,  EOMONTH(o.EstimatedCloseDate),  o.Category  ORDER BY   CATEGORY DESC"

function createOptions(values) {
  var options = []
  for (let i = 0; i < values.length; i++) {
    var col = { value: values[i], text: values[i] }
    options.push(col)
  }
  return options
}

function createOptionsFilter(graphConf) {
  var options = []
  console.log('GraphConf:', graphConf)
  for (let i = 0; i < graphConf.columns.length; i++) {
    if (graphConf.columns[i].aggregation === false && graphConf.columns[i].filter === null) {
      console.log('Filter:', graphConf.columns[i].filter)

      var col = { value: graphConf.columns[i], text: graphConf.columns[i].alias }
      options.push(col)
    }
  }
  return options
}

const DateFilter = ({ to, setTo, from, setFrom, error }) => {
  const handleToChange = (event) => {
    setTo(event.target.value)
  }

  const handleFromChange = (event) => {
    setFrom(event.target.value)
  }

  return (
    <div className="Date-Filter">
      {error && <p>{'Something was wrong with the input please correct it and try again'}</p>}
      <one-ux-text class="one-ux-typography--body-400">From:</one-ux-text>
      <one-ux-input onChange={handleFromChange} placeholder="yyyy-mm-dd" value={from} width="4/12"></one-ux-input>
      <one-ux-text class="one-ux-typography--body-400">To:</one-ux-text>
      <one-ux-input onChange={handleToChange} placeholder="yyyy-mm-dd" value={to} width="4/12"></one-ux-input>
    </div>
  )
}

const DateGraphFilter = ({ column, graphConf, setGraphConf, setGraphData }) => {
  const [from, setFrom] = useState('')
  const [to, setTo] = useState('')
  const [error, setError] = useState(false)

  const isValidDate = (input) => {
    const regex = /^\d{4}-\d{2}-\d{2}$/
    if (!regex.test(input)) {
      return false
    }

    const [year, month, day] = input.split('-').map(Number)
    const date = new Date(year, month - 1, day)
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
  }

  const handleDate = async (i_from, i_to) => {
    let t_from = i_from
    let t_to = i_to
    setError(false)
    if (!isValidDate(i_from) && i_from !== '' && i_from !== undefined) {
      console.log(i_from)
      setError(true)
      return
    }
    if (!isValidDate(i_to) && i_to !== '' && i_to !== undefined) {
      console.log(i_to)
      setError(true)
      return
    }
    if (i_from === '') {
      t_from = '1970-01-01'
    }
    if (i_to === '') {
      t_to = '2100-01-01'
    }
    column.filter = { operator: 'BETWEEN', values: [t_from, t_to], typ: 'date' }
    const tempGraphConf = {
      ...graphConf,
      columns: graphConf.columns.map((col) => (col.name === column.name ? column : col))
    }
    setGraphConf(tempGraphConf)
    const response = await window.PDR.api.post(`${endpoints[window.location.host]}/getgraph`, {
      graphConf: tempGraphConf
    })
    console.log(response)
    setGraphData(response)
  }

  const handleToChange = (event) => {
    let temp = '1970-01-01'
    if (column.filter) {
      temp = column.filter.values[0]
    }
    handleDate(temp, event.target.value)
  }

  const handleFromChange = (event) => {
    let temp = '2100-01-01'
    if (column.filter) {
      temp = column.filter.values[1]
    }
    handleDate(event.target.value, temp)
  }

  const handleRemove = async () => {
    var pickedColumn = column
    const tempGraphConf = {
      ...graphConf,
      columns: graphConf.columns.map((col) => (col.name === pickedColumn.name ? { ...col, filter: null } : col))
    }
    console.log('Inne i remove')
    console.log(tempGraphConf)
    setGraphConf(tempGraphConf)

    const response = await window.PDR.api.post(`${endpoints[window.location.host]}/getgraph`, {
      graphConf: tempGraphConf
    })
    console.log(response)
    setGraphData(response)
  }

  return (
    <div className="DateGraphFilter">
      <one-ux-text class="one-ux-typography--heading-200">{column.alias}</one-ux-text>
      {error && <p>Error</p>}
      <div className="Date-Filter">
        <one-ux-text class="one-ux-typography--body-400">From:</one-ux-text>
        <one-ux-input
          onChange={handleFromChange}
          placeholder="yyyy-mm-dd"
          value={column.filter.values[0]}
          width="4/12"></one-ux-input>
        <one-ux-text class="one-ux-typography--body-400">To:</one-ux-text>
        <one-ux-input
          onChange={handleToChange}
          placeholder="yyyy-mm-dd"
          value={column.filter.values[1]}
          width="4/12"></one-ux-input>
      </div>
      {column.aggregation === false && column.filter.locked === false && (
        <one-ux-button label="Add" implicit={true} onClick={handleRemove}>
          <one-ux-icon icon="remove"></one-ux-icon>
        </one-ux-button>
      )}
    </div>
  )
}

const FilterDropdown = ({ column, graphConf, setGraphData, setGraphConf }) => {
  const [checked, setChecked] = useState([])
  const [values, setValues] = useState([])

  const handleCheckbox = async (event) => {
    console.log('Checkbox:', event.target.value)

    var temp = event.target.value
    if (temp.length === 0) {
      temp = column.values.filter((value) => value !== null)
      console.log(temp)
    }
    setChecked(temp)
    column.filter = { operator: column.filter.operator, values: temp, typ: 'discrete', locked: column.filter.locked }
    const tempGraphConf = {
      ...graphConf,
      columns: graphConf.columns.map((col) => (col.name === column.name ? column : col))
    }

    setGraphConf(tempGraphConf)

    const response = await window.PDR.api.post(`${endpoints[window.location.host]}/getgraph`, {
      graphConf: tempGraphConf
    })
    console.log(response)
    setGraphData(response)
  }
  const handleRemove = async () => {
    var pickedColumn = column
    const tempGraphConf = {
      ...graphConf,
      columns: graphConf.columns.map((col) => (col.name === pickedColumn.name ? { ...col, filter: null } : col))
    }
    console.log('Inne i remove')
    console.log(tempGraphConf)
    setGraphConf(tempGraphConf)

    const response = await window.PDR.api.post(`${endpoints[window.location.host]}/getgraph`, {
      graphConf: tempGraphConf
    })
    console.log(response)
    setGraphData(response)
  }
  const display_options = [
    { value: 'line', text: 'Line' },
    { value: 'column', text: 'Bar' },
    { value: 'area', text: 'Area' },
    { value: 'column-stacked', text: 'Stacked columns' }
  ]

  return (
    <div
      className="filter-dropdown"
      style={{ opacity: column.aggregation === false && column.filter.locked === false ? 1 : 0.5 }}>
      <one-ux-dropdown placeholder={'Pick an option'} width="auto" disabled={column.filter.locked}>
        <div
          slot="preview"
          style={{
            display: 'inline-block'
          }}>
          <one-ux-text class="one-ux-typography--heading-200">{column.alias}</one-ux-text>
          <one-ux-text class="one-ux-typography--body-200">{' IN '}</one-ux-text>
          <one-ux-text class="one-ux-typography--body-200">
            {column.filter.values.join(', ').length > 40
              ? `${column.filter.values.join(', ').substring(0, 37)}...`
              : column.filter.values.join(', ')}
          </one-ux-text>
        </div>
        <one-ux-list
          multiple
          options={createOptions(column.values)}
          value={column.filter.values}
          onInput={handleCheckbox}></one-ux-list>
      </one-ux-dropdown>
      {column.aggregation === false && column.filter.locked === false && (
        <one-ux-button label="Add" implicit={true} onClick={handleRemove}>
          <one-ux-icon icon="remove"></one-ux-icon>
        </one-ux-button>
      )}
    </div>
  )
}

const NumBoxFilter = ({ column, graphConf, setGraphConf, setGraphData }) => {
  const [numeric, setNumeric] = useState(column.filter.values[0])
  const [operator, setOperator] = useState(column.filter.operator)
  const handleNumericChange = async (event) => {
    column.filter = { operator: operator, values: [event.target.value], typ: 'num' }
    const tempGraphConf = {
      ...graphConf,
      columns: graphConf.columns.map((col) => (col.name === column.name ? column : col))
    }
    setGraphConf(tempGraphConf)
    console.log(tempGraphConf)
    const response = await window.PDR.api.post(`${endpoints[window.location.host]}/getgraph`, {
      graphConf: tempGraphConf
    })
    console.log(response)
    setGraphData(response)
  }
  const handleChangeOperator = async (event) => {
    setOperator(event.target.value[0])
    column.filter = { operator: event.target.value[0], values: [numeric], typ: 'num' }
    const tempGraphConf = {
      ...graphConf,
      columns: graphConf.columns.map((col) => (col.name === column.name ? column : col))
    }
    //setGraphConf(tempGraphConf)
    console.log(tempGraphConf)
    const response = await window.PDR.api.post(`${endpoints[window.location.host]}/getgraph`, {
      graphConf: tempGraphConf
    })
    console.log(response)
    setGraphData(response)
  }

  const handleRemove = async () => {
    var pickedColumn = column
    const tempGraphConf = {
      ...graphConf,
      columns: graphConf.columns.map((col) => (col.name === pickedColumn.name ? { ...col, filter: null } : col))
    }
    console.log('Inne i remove')
    console.log(tempGraphConf)
    setGraphConf(tempGraphConf)

    const response = await window.PDR.api.post(`${endpoints[window.location.host]}/getgraph`, {
      graphConf: tempGraphConf
    })
    console.log(response)
    setGraphData(response)
  }

  // const handleUpdate = async () => {
  //   column.filter = { operator: operator, values: [numeric], typ: 'num' }
  //   const tempGraphConf = {
  //     ...graphConf,
  //     columns: graphConf.columns.map((col) => (col.name === column.name ? column : col))
  //   }
  //   //setGraphConf(tempGraphConf)
  //   console.log(tempGraphConf)
  //   const response = await window.PDR.api.post(`${endpoints[window.location.host]}/getgraph`, {
  //     graphConf: tempGraphConf
  //   })
  //   console.log(response)
  //   setGraphData(response)
  // }

  return (
    <div className="filter-numbox">
      <one-ux-text class="one-ux-typography--heading-200">{column.alias}</one-ux-text>
      <one-ux-dropdown placeholder={'Operator'} width="2/12" disabled={column.filter.locked}>
        <one-ux-list
          onInput={handleChangeOperator}
          value={[operator]}
          options={[
            { value: '>', text: '>' },
            { value: '<', text: '<' },
            { value: '=', text: '=' },
            { value: '!=', text: '!=' }
          ]}></one-ux-list>
      </one-ux-dropdown>
      <one-ux-input
        width="4/12"
        onChange={handleNumericChange}
        value={column.filter.values[0]}
        placeholder="Input numeric value"></one-ux-input>
      {(column.aggregation === false || column.locked === false) && (
        <one-ux-button label="Add" implicit={true} onClick={handleRemove}>
          <one-ux-icon icon="remove"></one-ux-icon>
        </one-ux-button>
      )}
    </div>
  )
}

const Dashboards = () => {
  const navigate = useNavigate()
  const display_options = [
    { value: 'line', text: 'Line' },
    { value: 'column', text: 'Bar' },
    { value: 'area', text: 'Area' },
    { value: 'column-stacked', text: 'Stacked columns' }
  ]
  const { state } = useLocation()
  const [query, setQuery] = useState(state?.sql)
  const [graphConf, setGraphConf] = useState(state?.graphConfig || {})
  const [graphData, setGraphData] = useState({})
  const [displayG, setDisplayG] = useState(false)
  const [operator, setOperator] = useState('')
  const [pickedC, setPickedC] = useState('')
  const [currentOptions, setCurrentOptions] = useState([])
  const [id, setId] = useState(state?.id)
  const userId = state?.userId
  const userMail = state?.userMail

  const operator_options = {
    discrete: [
      { value: 'IN', text: 'In' },
      { value: 'NOT IN', text: 'Not in' }
    ],
    num: [
      { value: '>', text: '>' },
      { value: '<', text: '<' },
      { value: '=', text: '=' },
      { value: '!=', text: '!=' }
    ],
    date: [{ value: 'BETWEEN', text: 'Between' }]
  }

  const handleAddFilterDropdown = async (event) => {
    setPickedC(event.target.value[0])
    console.log('Picked:', event.target.value[0])
    console.log(operator_options[event.target.value[0].data_type])
    setCurrentOptions(operator_options[event.target.value[0].data_type])
  }

  const handleChangeOperator = async (event) => {
    setOperator(event.target.value[0])
  }

  const addFilter = async (column) => {
    if (column.data_type === 'date') {
      column.filter = { operator: operator, values: ['1970-01-01', '2100-01-01'], typ: column.data_type, locked: false }
    } else {
      column.filter = { operator: operator, values: column.values, typ: column.data_type, locked: false }
    }
    const tempGraphConf = {
      ...graphConf,
      columns: graphConf.columns.map((col) => (col.name === column.name ? column : col))
    }
    setGraphConf(tempGraphConf)
    console.log('ADDGraphConf:', tempGraphConf)
    setPickedC('')

    const response = await window.PDR.api.post(`${endpoints[window.location.host]}/getgraph`, {
      graphConf: tempGraphConf
    })
    console.log(response)
    setGraphData(response)
  }

  const handleSearch = async () => {
    console.log('Searching for:', query)
    setDisplayG(false)
    const response = await window.PDR.api.post(`${endpoints[window.location.host]}/getstructure`, { query })

    console.log(response)
    setGraphConf(response)

    // Perform search logic here using the searchTerm state
    // Update the searchResult state with the fetched data
  }

  const handleTitleChange = (event) => {
    console.log('Title:', event.target.value)
    setGraphConf({ ...graphConf, name: event.target.value })
  }

  const handleDescription = (event) => {
    console.log('Description:', event.target.value)
    setGraphConf({ ...graphConf, description: event.target.value })
  }

  const handleMock = async () => {
    const response = await window.PDR.api.post(`${endpoints[window.location.host]}/testsql`, { query })
    console.log(response)
  }

  const handleDiagramType = async (event) => {
    console.log('Diagram:', event.target.value)
    let tempGraphConf = { ...graphConf, display_type: event.target.value[0] }
    setGraphConf(tempGraphConf)
    const response = await window.PDR.api.post(`${endpoints[window.location.host]}/getgraph`, {
      graphConf: tempGraphConf
    })
    setGraphData(response)
  }

  const discretOptions = [
    { value: 'IN', text: 'In' },
    { value: 'NOT IN', text: 'Not in' }
  ]

  useEffect(() => {
    const fetchData = async () => {
      const response = await window.PDR.api.post(`${endpoints[window.location.host]}/getgraph`, {
        graphConf: state?.graphConfig
      })
      console.log(response)
      setGraphData(response)
      setDisplayG(true)
    }
    console.log('State:', state)
    console.log('GraphConf:', state?.graphConfig)

    fetchData()
  }, [])

  return (
    <div className="root">
      <div className="header1">
        {/* Flex item for icon and text on the left */}
        <img
          className="stratsys-search-logo"
          src="https://frontend-packages.svc.stratsys.com/logos/icon-dark.svg"
          alt="Stratsys Icon"
          style={{ width: '100px', height: 'auto' }}
        />
        <div className="one-ux-typography--heading-500" style={{ marginLeft: '30px' }}>
          <one-ux-text className="dashboard-heading">Stratsys AI Dashboards</one-ux-text>
        </div>
      </div>

      {displayG === false && (
        <div className="spinner">
          <div class="typing-indicator2">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )}

      <div className="search-container">
        {/* {displayG == false && (
          <div className="search-container2">
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Input SQL query here..."
              className="search-input"
            />
            <one-ux-button
              class="structure-button"
              label="Create graph structure"
              purpose="defualt"
              weight="normal"
              onClick={handleSearch}></one-ux-button>
          </div>
        )} */}

        {/* <one-ux-button
          class="structure-button"
          label="Mock Query"
          purpose="defualt"
          weight="normal"
          onClick={handleMock}></one-ux-button> */}
        {/* 
        <ColumnPicker
          columns={graphConf.columns}
          displayG={displayG}
          setDisplayG={setDisplayG}
          setGraphData={setGraphData}
          graphConf={graphConf}
          setGraphConf={setGraphConf}
        /> */}
        {Object.keys(graphData).length > 0 && displayG === true && (
          <div className="dashboard-content">
            <p className="dashboard-title">{id ? 'Edit graph' : 'Create graph'}</p>

            <div className="dashboard-menu">
              <div className="dashboard-menu-left">
                <p className="dashboard-subtitle">General</p>
                <one-ux-field label="Title" width="11/12">
                  <one-ux-textarea
                    placeholder="Write your title here..."
                    line-count="1"
                    value={graphConf.name}
                    onInput={handleTitleChange}></one-ux-textarea>
                </one-ux-field>
                <one-ux-field label="Description" width="11/12">
                  <one-ux-textarea
                    placeholder="Write your description here..."
                    line-count="4"
                    value={graphConf.description}
                    onInput={handleDescription}></one-ux-textarea>
                </one-ux-field>
                <one-ux-field label="Diagram type" width="11/12">
                  <one-ux-dropdown placeholder={'Pick an option'}>
                    <one-ux-list
                      options={display_options}
                      onInput={handleDiagramType}
                      value={[graphConf.display_type]}></one-ux-list>
                  </one-ux-dropdown>
                </one-ux-field>
              </div>
              <div className="dashboard-menu-right">
                <p className="dashboard-subtitle2">Filters</p>
                <div className="add-filter-container">
                  <one-ux-field label="Column" width="4/12" compact={true}>
                    <one-ux-dropdown placeholder={'Pick an option'}>
                      <one-ux-list
                        onInput={handleAddFilterDropdown}
                        value={[pickedC]}
                        options={createOptionsFilter(graphConf)}></one-ux-list>
                    </one-ux-dropdown>
                  </one-ux-field>
                  <one-ux-field label="Operator" width="4/12" compact={true}>
                    <one-ux-dropdown placeholder={'Pick an option'}>
                      <one-ux-list
                        onInput={handleChangeOperator}
                        options={currentOptions}
                        value={[operator]}></one-ux-list>
                    </one-ux-dropdown>
                  </one-ux-field>

                  <one-ux-button
                    disabled={pickedC === '' || operator === ''}
                    label="Add filter"
                    onClick={() => addFilter(pickedC)}>
                    <one-ux-icon slot="start" icon="add"></one-ux-icon>
                  </one-ux-button>
                </div>
                <div className="generated-filters">
                  {graphConf.columns
                    .filter((col) => col.filter !== null)
                    .map((item) => {
                      return item.filter.typ === 'num' ? (
                        <NumBoxFilter
                          key={item.name}
                          column={item}
                          graphConf={graphConf}
                          setGraphConf={setGraphConf}
                          setGraphData={setGraphData}></NumBoxFilter>
                      ) : item.filter.typ === 'date' ? (
                        <DateGraphFilter
                          key={item.name}
                          column={item}
                          graphConf={graphConf}
                          setGraphConf={setGraphConf}
                          setGraphData={setGraphData}></DateGraphFilter>
                      ) : (
                        <FilterDropdown
                          key={item.name}
                          column={item}
                          graphConf={graphConf}
                          setGraphConf={setGraphConf}
                          setGraphData={setGraphData}
                        />
                      )
                    })}
                </div>
              </div>
            </div>
            <p className="dashboard-subtitle3">Preview</p>
            <Graph
              graphData={graphData}
              graphConf={graphConf}
              setGraphConf={setGraphConf}
              setGraphData={setGraphData}
            />

            <one-ux-button
              class="save-button"
              label="Save graph"
              purpose="main"
              weight="normal"
              onClick={async () => {
                console.log(userId)
                const response = await window.PDR.api.post(`${endpoints[window.location.host]}/savegraph`, {
                  graphConf,
                  userId,
                  id
                })
                console.log(response)
                navigate(`/dashboardpage`, {
                  state: { userId }
                })
              }}></one-ux-button>
          </div>
        )}
      </div>
    </div>
  )
}

export default Dashboards
